/* Le Noir - tailoring measurement property names.

   The product options app renders its measurement fields with the labels set on
   the product page (SHOULDER, SLEEVE, UNDERARM, ...) but submits them under its
   own internal field names, so the cart, the order and the confirmation email
   all read "text-1: 78" instead of "SHOULDER: 78".

   The app mirrors every visible field into a hidden input named
   properties[<field name>] inside the product form. This renames those hidden
   inputs to the label shown above the field, and drops the ones left empty so a
   blank measurement never reaches the cart.

   The root fix is to rename the fields inside the options app itself; this keeps
   the cart readable until that is done. */

(function () {
  var CONTAINER = '.gpo-container';
  var scheduled = false;

  function cleanLabel(text) {
    return (text || '').replace(/\s+/g, ' ').replace(/[\[\]*]/g, '').trim();
  }

  function labelFor(field) {
    var id = field.id || field.getAttribute('data-field-name');
    if (!id) return '';
    var label = document.querySelector(CONTAINER + ' label.gpo-label[for="' + id + '"]');
    if (!label) return '';
    return cleanLabel((label.querySelector('.label-content') || label).textContent);
  }

  function valueOf(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      return field.checked ? field.value : '';
    }
    return field.value == null ? '' : String(field.value);
  }

  function productForm() {
    var container = document.querySelector(CONTAINER);
    return container ? container.closest('form[action*="/cart/add"]') : null;
  }

  function apply() {
    var form = productForm();
    if (!form) return;

    var fields = form.querySelectorAll(
      CONTAINER + ' input[data-field-name], ' +
      CONTAINER + ' select[data-field-name], ' +
      CONTAINER + ' textarea[data-field-name]'
    );

    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var key = field.getAttribute('data-field-name');
      var label = labelFor(field);
      if (!key || !label || label === key) continue;

      /* Make the app use the label the next time it mirrors this field. */
      field.setAttribute('data-name', 'properties[' + label + ']');

      var stale = form.querySelector('input[type="hidden"][name="properties[' + key + ']"]');
      var target = form.querySelector('input[type="hidden"][name="properties[' + label + ']"]');

      if (stale && !target) {
        /* Rename in place so the properties keep their original order. */
        stale.name = 'properties[' + label + ']';
        target = stale;
      } else if (stale && target) {
        stale.parentNode.removeChild(stale);
      }

      var value = valueOf(field).trim();

      if (!value) {
        if (target) target.parentNode.removeChild(target);
        continue;
      }

      if (!target) {
        target = document.createElement('input');
        target.type = 'hidden';
        target.name = 'properties[' + label + ']';
        form.appendChild(target);
      }

      target.value = value;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      apply();
    }, 0);
  }

  /* Authoritative pass, before the theme serialises the form. */
  window.addEventListener('submit', apply, true);

  /* Keep the hidden inputs correct while the shopper types, so any other code
     that reads the form also sees the right names. */
  document.addEventListener('input', function (event) {
    if (event.target && event.target.closest && event.target.closest(CONTAINER)) schedule();
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest(CONTAINER)) schedule();
  }, true);

  /* The options app renders asynchronously; adopt its fields once they appear. */
  var tries = 0;
  var timer = setInterval(function () {
    if (++tries > 60) clearInterval(timer);
    if (document.querySelector(CONTAINER)) apply();
  }, 500);
})();
